define('core/id-headers',["exports", "core/utils"], function (exports, _utils) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.name = undefined;
  exports.run = run;
  // Module core/id-headers
  // All headings are expected to have an ID, unless their immediate container has one.
  // This is currently in core though it comes from a W3C rule. It may move in the future.

  const name = exports.name = "core/id-headers";
  function run(conf) {
    document.querySelectorAll(`
      section:not(.introductory) h2,
      section:not(.introductory) h3,
      section:not(.introductory) h4,
      section:not(.introductory) h5,
      section:not(.introductory) h6`).forEach(elem => {
      (0, _utils.addId)(elem);
      if (conf.addSectionLinks) {
        addSectionLink(elem);
      }
    });
  }

  function addSectionLink(h) {
    const section = h.closest("section[id]");
    const id = section ? section.id : h.id;
    h.appendChild(hyperHTML`
    <a href="${"#" + id}" class="self-link" aria-label="§"></a>
  `);
  }
});
//# sourceMappingURL=id-headers.js.map;
